"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFirebaseApp = exports.getAppAsync = exports.getAnalyticsAsync = exports.getFunctionsAsync = exports.getStorageAsync = exports.getAuthAsync = exports.getFirestoreAsync = exports.isFirebaseInitialized = exports.getGoogleProvider = exports.getFirebaseAnalytics = exports.getFirebaseFunctions = exports.getFirebaseStorage = exports.getFirebaseAuth = exports.getDb = exports.firebaseManager = void 0;
const app_1 = require("firebase/app");
const firestore_1 = require("firebase/firestore");
const auth_1 = require("firebase/auth");
const storage_1 = require("firebase/storage");
const functions_1 = require("firebase/functions");
const app_check_1 = require("firebase/app-check");
const environment_1 = require("../config/environment");
const appConfig_1 = require("./appConfig");
/**
 * True only when the app runs inside the native Capacitor shell (iOS/Android).
 * Must NOT use mobile User-Agent alone — mobile Safari/Chrome is still web and needs
 * Firestore persistence; treating it as "native" disabled cache and caused wrong logs.
 */
const isNativePlatform = () => {
    if (typeof window === 'undefined')
        return false;
    const Cap = window.Capacitor;
    if (Cap && typeof Cap.isNativePlatform === 'function') {
        try {
            return Cap.isNativePlatform();
        }
        catch (_a) {
            return false;
        }
    }
    return false;
};
/** React Native / Expo runtime (distinct from Capacitor or mobile browser). */
const isReactNative = typeof navigator !== 'undefined' && navigator.product === 'ReactNative';
class FirebaseManager {
    constructor() {
        this.app = null;
        this.firestore = null;
        this.auth = null;
        this.storage = null;
        this.functions = null;
        this.analytics = null;
        /** In-flight lazy load of firebase/analytics (dynamic import — keeps startup fast). */
        this.analyticsLazyPromise = null;
        this.isInitialized = false;
        this.initializationPromise = null;
    }
    static getInstance() {
        if (!FirebaseManager.instance) {
            FirebaseManager.instance = new FirebaseManager();
        }
        return FirebaseManager.instance;
    }
    /**
     * Get Firebase configuration based on platform and environment
     */
    getFirebaseConfig() {
        var _a, _b, _c;
        // Detect platform - CRITICAL: Check for native Capacitor FIRST before falling back to web
        const isCapacitorNative = typeof window !== 'undefined' && window.Capacitor !== undefined;
        const isNode = typeof process !== 'undefined' && ((_a = process.versions) === null || _a === void 0 ? void 0 : _a.node);
        const isWeb = typeof window !== 'undefined' && !isCapacitorNative;
        let config;
        let useEmulators = false;
        if (isCapacitorNative) {
            // CRITICAL: Detect whether we are on Android or iOS
            const platform = typeof window !== 'undefined' ? (_b = window.Capacitor) === null || _b === void 0 ? void 0 : _b.getPlatform() : 'ios';
            console.log(`🔥 FirebaseManager: Detected Capacitor native platform - ${platform}`);
            if (platform === 'android') {
                // Android-specific configuration from google-services.json
                config = {
                    apiKey: "AIzaSyAx8SrTatPPCdKLJc5nvQmyzmu3SD3XIk0",
                    authDomain: "watchlists-1c639.firebaseapp.com",
                    projectId: "watchlists-1c639",
                    storageBucket: "watchlists-1c639.firebasestorage.app",
                    messagingSenderId: "418607615172",
                    appId: "1:418607615172:android:16290896bb25b1e2864d91",
                };
            }
            else {
                // iOS-specific configuration from GoogleService-Info.plist
                config = {
                    apiKey: "AIzaSyARNOutwcHejPHTtjR_24JXWqFwEbqxAi0",
                    authDomain: "watchlists-1c639.firebaseapp.com",
                    projectId: "watchlists-1c639",
                    storageBucket: "watchlists-1c639.firebasestorage.app",
                    messagingSenderId: "418607615172",
                    appId: "1:418607615172:ios:64c27c5ee3ccf864864d91",
                };
            }
            useEmulators = false; // Never use emulators on native
        }
        else if (isWeb) {
            // Web platform - use environment variables
            config = {
                apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAzDO-bf5yFLAFnCWx16DaMSvTfH98HTI4",
                authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "watchlists-1c639.firebaseapp.com",
                projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "watchlists-1c639",
                storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "watchlists-1c639.firebasestorage.app",
                messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "418607615172",
                appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:418607615172:web:10d2509b05a68f7c864d91",
                measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-D8LWR49JVD"
            };
            // Use emulators in development
            useEmulators = process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_EMULATORS === 'true';
        }
        else if (isReactNative) {
            // React Native platform - use Expo constants or react-native-config
            try {
                const expoConstants = 'expo-constants';
                const Constants = require(expoConstants);
                const extra = ((_c = Constants.expoConfig) === null || _c === void 0 ? void 0 : _c.extra) || {};
                config = {
                    apiKey: extra.FIREBASE_API_KEY,
                    authDomain: `${extra.FIREBASE_PROJECT_ID}.firebaseapp.com`,
                    projectId: extra.FIREBASE_PROJECT_ID,
                    storageBucket: `${extra.FIREBASE_PROJECT_ID}.appspot.com`,
                    messagingSenderId: extra.FIREBASE_MESSAGING_SENDER_ID,
                    appId: extra.FIREBASE_APP_ID,
                    measurementId: extra.FIREBASE_MEASUREMENT_ID
                };
            }
            catch (_d) {
                throw new Error('Firebase configuration not found in React Native environment');
            }
        }
        else if (isNode) {
            // Node.js platform (Firebase Functions)
            config = {
                apiKey: process.env.FIREBASE_API_KEY || "",
                authDomain: `${process.env.FIREBASE_PROJECT_ID}.firebaseapp.com`,
                projectId: process.env.FIREBASE_PROJECT_ID || "watchlists-1c639",
                storageBucket: `${process.env.FIREBASE_PROJECT_ID}.appspot.com`,
                messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID || "",
                appId: process.env.FIREBASE_APP_ID || "",
                measurementId: process.env.FIREBASE_MEASUREMENT_ID
            };
        }
        else {
            throw new Error('Unknown platform - cannot determine Firebase configuration');
        }
        // Validate required fields
        if (!config.projectId) {
            throw new Error('Firebase projectId is required but not found in environment configuration');
        }
        return {
            config,
            useEmulators,
            emulatorPorts: {
                firestore: 8080,
                auth: 9099,
                functions: 5001
            }
        };
    }
    /**
     * Load Firebase Analytics after the main thread is idle so Capacitor/WebView startup stays fast.
     * First explicit `getAnalytics()` still triggers load immediately via ensureAnalyticsLazyLoaded.
     */
    scheduleDeferredAnalyticsInit() {
        if (typeof window === 'undefined') {
            return;
        }
        if (!environment_1.features.enableAnalytics) {
            if (environment_1.features.enableDebugMode) {
                console.log('📈 FirebaseManager: Analytics disabled (set REACT_APP_ENABLE_ANALYTICS=true in dev to enable GA4 / DebugView)');
            }
            return;
        }
        const run = () => {
            void this.ensureAnalyticsLazyLoaded();
        };
        const w = window;
        if (typeof w.requestIdleCallback === 'function') {
            w.requestIdleCallback(run, { timeout: 4000 });
        }
        else {
            setTimeout(run, 2000);
        }
    }
    /**
     * Dynamic import of firebase/analytics — avoids pulling the SDK on the critical init path.
     */
    ensureAnalyticsLazyLoaded() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!environment_1.features.enableAnalytics) {
                return;
            }
            if (this.analytics !== null) {
                return;
            }
            if (!this.app) {
                return;
            }
            if (!this.analyticsLazyPromise) {
                this.analyticsLazyPromise = (() => __awaiter(this, void 0, void 0, function* () {
                    try {
                        const { getAnalytics } = yield Promise.resolve().then(() => __importStar(require('firebase/analytics')));
                        this.analytics = getAnalytics(this.app);
                        console.log('📈 FirebaseManager: Analytics lazy-initialized');
                    }
                    catch (error) {
                        console.warn('🔥 FirebaseManager: Analytics lazy init failed (offline or unsupported):', error);
                        this.analytics = null;
                    }
                }))();
            }
            yield this.analyticsLazyPromise;
        });
    }
    /**
     * Initialize Firebase (idempotent and thread-safe)
     */
    initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            // Skip Firebase initialization for React Native development
            if (isReactNative && process.env.NODE_ENV === 'development') {
                console.log('🚧 FirebaseManager: Skipping initialization for React Native development');
                this.isInitialized = true;
                return;
            }
            // Return existing initialization promise if already initializing
            if (this.initializationPromise) {
                return this.initializationPromise;
            }
            // Return immediately if already initialized
            if (this.isInitialized) {
                return;
            }
            // Create initialization promise
            this.initializationPromise = this.performInitialization();
            try {
                yield this.initializationPromise;
            }
            finally {
                this.initializationPromise = null;
            }
        });
    }
    performInitialization() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                console.log('🔥 FirebaseManager: Starting initialization...');
                const platformConfig = this.getFirebaseConfig();
                const { config, useEmulators, emulatorPorts } = platformConfig;
                // Enhanced debugging: Check if app already exists (prevents multiple initialization)
                const appName = '[DEFAULT]';
                const existingApps = (0, app_1.getApps)();
                console.log('🔍 FIREBASE APP DEBUGGING:', {
                    existingAppsCount: existingApps.length,
                    existingAppNames: existingApps.map(app => app.name),
                    requestedAppName: appName,
                    timestamp: new Date().toISOString()
                });
                if (existingApps.length > 0) {
                    // CRITICAL FIX: Check if we have a DEFAULT app or just named apps
                    let defaultApp = null;
                    try {
                        defaultApp = (0, app_1.getApp)(); // This gets the [DEFAULT] app
                        console.log('🔥 FirebaseManager: Found DEFAULT Firebase app');
                    }
                    catch (error) {
                        console.log('🔥 FirebaseManager: No DEFAULT app found, but other apps exist:', existingApps.map(a => a.name));
                    }
                    if (defaultApp) {
                        this.app = defaultApp;
                        console.log('🔥 FirebaseManager: Using existing DEFAULT Firebase app');
                        console.log('🔍 EXISTING DEFAULT APP DETAILS:', {
                            appName: this.app.name,
                            projectId: this.app.options.projectId,
                            authDomain: this.app.options.authDomain,
                            apiKey: ((_a = this.app.options.apiKey) === null || _a === void 0 ? void 0 : _a.substring(0, 10)) + '...'
                        });
                    }
                    else {
                        // No DEFAULT app found, create one even though other named apps exist
                        this.app = (0, app_1.initializeApp)(config);
                        console.log('🔥 FirebaseManager: Created new DEFAULT Firebase app (named apps existed but no DEFAULT)');
                        console.log('🔍 NEW DEFAULT APP DETAILS:', {
                            appName: this.app.name,
                            projectId: this.app.options.projectId,
                            authDomain: this.app.options.authDomain,
                            apiKey: ((_b = this.app.options.apiKey) === null || _b === void 0 ? void 0 : _b.substring(0, 10)) + '...'
                        });
                    }
                }
                else {
                    this.app = (0, app_1.initializeApp)(config);
                    console.log('🔥 FirebaseManager: Created new Firebase app (no existing apps)');
                    console.log('🔍 NEW APP DETAILS:', {
                        appName: this.app.name,
                        projectId: this.app.options.projectId,
                        authDomain: this.app.options.authDomain,
                        apiKey: ((_c = this.app.options.apiKey) === null || _c === void 0 ? void 0 : _c.substring(0, 10)) + '...'
                    });
                }
                // Initialize App Check BEFORE other services
                // This ensures all Firebase requests have App Check tokens
                yield this.initializeAppCheck(this.app);
                // Initialize services
                // CRITICAL FIX FOR iOS: Detect native platform and skip persistence
                // iOS WKWebView has IndexedDB restrictions that cause Firestore persistence to hang
                const isNative = isNativePlatform();
                const platform = typeof window !== 'undefined' ? (_e = (_d = window.Capacitor) === null || _d === void 0 ? void 0 : _d.getPlatform) === null || _e === void 0 ? void 0 : _e.call(_d) : 'unknown';
                console.log('📱 FirebaseManager: Platform detection for Firestore initialization:', {
                    isNative,
                    platform,
                    hasCapacitor: typeof window !== 'undefined' && !!window.Capacitor,
                    capacitorPlatform: typeof window !== 'undefined' ? (_g = (_f = window.Capacitor) === null || _f === void 0 ? void 0 : _f.getPlatform) === null || _g === void 0 ? void 0 : _g.call(_f) : 'N/A',
                    isNativePlatformCheck: typeof window !== 'undefined' ? (_j = (_h = window.Capacitor) === null || _h === void 0 ? void 0 : _h.isNativePlatform) === null || _j === void 0 ? void 0 : _j.call(_h) : 'N/A',
                    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : 'N/A'
                });
                if (isNative) {
                    console.log('📱 FirebaseManager: Native platform detected - initializing Firestore WITHOUT persistence');
                    // CRITICAL FIX FOR iOS: Use simple getFirestore() without any settings
                    // The experimentalForceLongPolling might be causing issues in Capacitor environment
                    this.firestore = (0, firestore_1.getFirestore)(this.app);
                    console.log('✅ FirebaseManager: Firestore initialized for iOS with default settings');
                }
                else {
                    console.log('🌐 FirebaseManager: Web platform detected - initializing Firestore WITH persistence');
                    try {
                        this.firestore = (0, firestore_1.initializeFirestore)(this.app, {
                            localCache: (0, firestore_1.persistentLocalCache)({
                                tabManager: (0, firestore_1.persistentMultipleTabManager)()
                            })
                        });
                        console.log('✅ FirebaseManager: Firestore initialized with offline persistence');
                    }
                    catch (error) {
                        console.warn('⚠️ FirebaseManager: Persistence initialization failed, falling back to default:', error);
                        this.firestore = (0, firestore_1.getFirestore)(this.app);
                    }
                }
                this.auth = (0, auth_1.getAuth)(this.app);
                // CRITICAL FIX FOR iOS: Set explicit auth persistence for native platforms
                // Without this, WKWebView may not persist auth state correctly, causing logout on app close
                // IMPORTANT: Wrap in a non-blocking try-catch to prevent initialization from hanging
                if (isNative) {
                    // Don't await - let persistence setup happen in background to avoid blocking init
                    // This fixes the race condition where setPersistence hangs on iOS simulator
                    (() => __awaiter(this, void 0, void 0, function* () {
                        try {
                            // Try indexedDBLocalPersistence first (most reliable for native)
                            yield (0, auth_1.setPersistence)(this.auth, auth_1.indexedDBLocalPersistence);
                            console.log('✅ FirebaseManager: Auth persistence set to indexedDB for native platform');
                        }
                        catch (persistenceError) {
                            console.warn('⚠️ FirebaseManager: indexedDB persistence failed, trying browserLocal:', persistenceError);
                            try {
                                // Fallback to browserLocalPersistence
                                yield (0, auth_1.setPersistence)(this.auth, auth_1.browserLocalPersistence);
                                console.log('✅ FirebaseManager: Auth persistence set to browserLocal for native platform');
                            }
                            catch (fallbackError) {
                                console.error('❌ FirebaseManager: All auth persistence methods failed:', fallbackError);
                                // Continue without explicit persistence - may still work with defaults
                            }
                        }
                    }))();
                }
                this.storage = (0, storage_1.getStorage)(this.app);
                this.functions = (0, functions_1.getFunctions)(this.app, 'us-central1');
                // Fetch app config. fetchAndActivate already fetches fresh from the network
                // (subject to the 1-hour cache), so a second force-refresh is redundant and
                // causes a double activation on every cold open for users who had maintenance cached.
                // Recovery is handled by MaintenanceScreen's 30s polling interval instead.
                void (0, appConfig_1.fetchAndActivateAppConfig)(this.app);
                // Analytics: defer — dynamic import of firebase/analytics after idle (Capacitor + web cold start).
                // Skipped entirely when features.enableAnalytics is false (see environment.ts).
                this.scheduleDeferredAnalyticsInit();
                // Connect to emulators in development
                if (useEmulators && emulatorPorts) {
                    try {
                        // Check if emulators are already connected (using safe property access)
                        try {
                            const firestoreSettings = (_l = (_k = this.firestore._delegate) === null || _k === void 0 ? void 0 : _k._databaseId) === null || _l === void 0 ? void 0 : _l.database;
                            if (!(firestoreSettings === null || firestoreSettings === void 0 ? void 0 : firestoreSettings.includes('emulator'))) {
                                (0, firestore_1.connectFirestoreEmulator)(this.firestore, 'localhost', emulatorPorts.firestore);
                                console.log('🔥 FirebaseManager: Connected to Firestore emulator');
                            }
                        }
                        catch (error) {
                            (0, firestore_1.connectFirestoreEmulator)(this.firestore, 'localhost', emulatorPorts.firestore);
                            console.log('🔥 FirebaseManager: Connected to Firestore emulator');
                        }
                        try {
                            const authConfig = this.auth.config;
                            if (!(authConfig === null || authConfig === void 0 ? void 0 : authConfig.emulator)) {
                                (0, auth_1.connectAuthEmulator)(this.auth, `http://localhost:${emulatorPorts.auth}`);
                                console.log('🔥 FirebaseManager: Connected to Auth emulator');
                            }
                        }
                        catch (error) {
                            (0, auth_1.connectAuthEmulator)(this.auth, `http://localhost:${emulatorPorts.auth}`);
                            console.log('🔥 FirebaseManager: Connected to Auth emulator');
                        }
                        try {
                            const functionsUrl = this.functions._url;
                            if (!(functionsUrl === null || functionsUrl === void 0 ? void 0 : functionsUrl.includes('localhost'))) {
                                (0, functions_1.connectFunctionsEmulator)(this.functions, 'localhost', emulatorPorts.functions);
                                console.log('🔥 FirebaseManager: Connected to Functions emulator');
                            }
                        }
                        catch (error) {
                            (0, functions_1.connectFunctionsEmulator)(this.functions, 'localhost', emulatorPorts.functions);
                            console.log('🔥 FirebaseManager: Connected to Functions emulator');
                        }
                    }
                    catch (error) {
                        console.log('🔥 FirebaseManager: Emulators already connected or unavailable:', error);
                    }
                }
                this.isInitialized = true;
                console.log('✅ FirebaseManager: Initialization completed successfully', {
                    projectId: config.projectId,
                    useEmulators,
                    hasAnalytics: !!this.analytics
                });
            }
            catch (error) {
                console.error('❌ FirebaseManager: Initialization failed:', error);
                this.isInitialized = false;
                throw error;
            }
        });
    }
    /**
     * Initialize App Check for all platforms
     * - Web: reCAPTCHA v3
     * - iOS/Android: Device attestation (handled by native SDKs)
     */
    initializeAppCheck(app) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                console.log('🛡️ FirebaseManager: Initializing App Check...');
                // Use the same native detection as Firestore (Capacitor may exist on web builds; only shell is "native").
                const nativeShell = isNativePlatform();
                if (!nativeShell) {
                    // Web / mobile browser — reCAPTCHA v3 (inlined at build time from packages/web/.env*)
                    const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
                    const debugToken = process.env.REACT_APP_APP_CHECK_DEBUG_TOKEN;
                    // Setting this before initializeAppCheck makes the SDK use the debug token
                    // instead of reCAPTCHA — required for incognito / CI / localhost testing
                    if (debugToken) {
                        self.FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken;
                        console.log('🔧 FirebaseManager: App Check debug token set (dev/incognito mode)');
                    }
                    if (!siteKey) {
                        console.warn('⚠️ FirebaseManager: reCAPTCHA site key not found. App Check disabled for web.');
                        console.warn('⚠️ Add REACT_APP_RECAPTCHA_SITE_KEY to packages/web/.env.local (Firebase Console → App Check → Web → reCAPTCHA v3 site key), then restart the dev server.');
                        return;
                    }
                    // Initialize App Check and wait for it to be ready
                    (0, app_check_1.initializeAppCheck)(app, {
                        provider: new app_check_1.ReCaptchaV3Provider(siteKey),
                        isTokenAutoRefreshEnabled: true
                    });
                    // Wait for App Check to get its first token
                    // reCAPTCHA v3 needs more time on initial load to fetch and validate the token
                    // This prevents race conditions where Firestore queries start before App Check is ready
                    yield new Promise(resolve => setTimeout(resolve, 2000));
                    console.log('✅ FirebaseManager: App Check initialized with reCAPTCHA v3 for web');
                }
                else {
                    // Capacitor iOS / Android shell
                    // The Capacitor plugin (initialized in capacitor-init.ts) holds the native token.
                    // We bridge it into the JS SDK via CustomProvider so every Firestore request
                    // automatically gets the App Attest (iOS) / Play Integrity (Android) token.
                    try {
                        const { FirebaseAppCheck } = yield Promise.resolve().then(() => __importStar(require('capacitor-firebase-app-check-patched')));
                        // CRITICAL FIX: Cache tokens to prevent excessive token fetches
                        // Without caching, every Firestore operation calls getToken() causing hundreds of requests
                        let cachedToken = null;
                        const TOKEN_BUFFER_MS = 5 * 60 * 1000; // Refresh 5 minutes before expiry
                        (0, app_check_1.initializeAppCheck)(app, {
                            provider: new app_check_1.CustomProvider({
                                getToken: () => __awaiter(this, void 0, void 0, function* () {
                                    var _a;
                                    // Return cached token if still valid
                                    if (cachedToken && cachedToken.expireTimeMillis > Date.now() + TOKEN_BUFFER_MS) {
                                        return cachedToken;
                                    }
                                    // Fetch fresh token from native plugin
                                    const result = yield FirebaseAppCheck.getToken({ forceRefresh: false });
                                    cachedToken = {
                                        token: result.token,
                                        expireTimeMillis: (_a = result.expireTimeMillis) !== null && _a !== void 0 ? _a : Date.now() + 3600000,
                                    };
                                    console.log('🔄 FirebaseManager: Fetched fresh App Check token from native plugin');
                                    return cachedToken;
                                }),
                            }),
                            isTokenAutoRefreshEnabled: true,
                        });
                        // CRITICAL FIX: Wait for native App Check to get its first token
                        // This matches the web implementation and prevents race conditions
                        // where Firestore initializes before the native bridge is ready.
                        yield new Promise(resolve => setTimeout(resolve, 800));
                        console.log('✅ FirebaseManager: App Check bridged from Capacitor plugin (iOS/Android) with token caching');
                    }
                    catch (bridgeError) {
                        console.error('❌ FirebaseManager: Failed to bridge native App Check token:', bridgeError);
                    }
                }
            }
            catch (error) {
                console.error('❌ FirebaseManager: App Check initialization failed:', error);
                // Don't throw - allow app to work without App Check in development
            }
        });
    }
    /**
     * Get initialized services (with automatic initialization)
     */
    getFirestore() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.initialize();
            if (!this.firestore) {
                throw new Error('Firestore not initialized');
            }
            return this.firestore;
        });
    }
    getAuth() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.initialize();
            if (!this.auth) {
                throw new Error('Auth not initialized');
            }
            return this.auth;
        });
    }
    getStorage() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.initialize();
            if (!this.storage) {
                throw new Error('Storage not initialized');
            }
            return this.storage;
        });
    }
    getFunctions() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.initialize();
            if (!this.functions) {
                throw new Error('Functions not initialized');
            }
            return this.functions;
        });
    }
    getAnalytics() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.initialize();
            if (!environment_1.features.enableAnalytics) {
                return null;
            }
            yield this.ensureAnalyticsLazyLoaded();
            return this.analytics;
        });
    }
    getApp() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.initialize();
            if (!this.app) {
                throw new Error('Firebase app not initialized');
            }
            return this.app;
        });
    }
    /**
     * SYNCHRONOUS getters for backward compatibility
     * These throw if not initialized yet
     */
    getDb() {
        if (!this.isInitialized || !this.firestore) {
            // For backward compatibility, try to wait briefly for auto-initialization
            if (this.initializationPromise) {
                console.warn('FirebaseManager: getDb() called before initialization completed. This may cause issues.');
            }
            throw new Error('Firestore not initialized. Call initialize() first or use async getFirestore()');
        }
        return this.firestore;
    }
    getAuthSync() {
        if (!this.isInitialized || !this.auth) {
            // For backward compatibility, try to wait briefly for auto-initialization
            if (this.initializationPromise) {
                console.warn('FirebaseManager: getAuthSync() called before initialization completed. This may cause issues.');
            }
            throw new Error('Auth not initialized. Call initialize() first or use async getAuth()');
        }
        return this.auth;
    }
    getStorageSync() {
        if (!this.isInitialized || !this.storage) {
            throw new Error('Storage not initialized. Call initialize() first or use async getStorage()');
        }
        return this.storage;
    }
    getFunctionsSync() {
        if (!this.isInitialized || !this.functions) {
            throw new Error('Functions not initialized. Call initialize() first or use async getFunctions()');
        }
        return this.functions;
    }
    getAnalyticsSync() {
        if (!this.isInitialized) {
            throw new Error('Firebase not initialized. Call initialize() first or use async getAnalytics()');
        }
        if (!environment_1.features.enableAnalytics) {
            return null;
        }
        return this.analytics;
    }
    /**
     * Check if Firebase is initialized (synchronous)
     */
    isReady() {
        return this.isInitialized;
    }
    /**
     * Wait for Firebase to be fully initialized (with timeout)
     * This is critical for avoiding race conditions where Firestore queries
     * are made before auth state is fully propagated.
     */
    waitForReady(timeoutMs = 5000) {
        return __awaiter(this, void 0, void 0, function* () {
            // If already initialized, return immediately
            if (this.isInitialized) {
                return true;
            }
            // If there's an initialization in progress, wait for it
            if (this.initializationPromise) {
                try {
                    yield Promise.race([
                        this.initializationPromise,
                        new Promise((_, reject) => setTimeout(() => reject(new Error('Initialization timeout')), timeoutMs))
                    ]);
                    return this.isInitialized;
                }
                catch (error) {
                    console.warn('FirebaseManager: waitForReady timeout, initialization may still be in progress');
                    return this.isInitialized;
                }
            }
            // Poll for initialization with timeout (fallback for edge cases)
            const startTime = Date.now();
            while (!this.isInitialized && Date.now() - startTime < timeoutMs) {
                yield new Promise(resolve => setTimeout(resolve, 100));
            }
            if (!this.isInitialized) {
                console.warn(`FirebaseManager: waitForReady timed out after ${timeoutMs}ms`);
            }
            return this.isInitialized;
        });
    }
    /**
     * Get Google Auth Provider (for login)
     */
    getGoogleAuthProvider() {
        const provider = new auth_1.GoogleAuthProvider();
        provider.setCustomParameters({
            prompt: 'select_account'
        });
        return provider;
    }
}
// Export singleton instance
exports.firebaseManager = FirebaseManager.getInstance();
// Export convenient SYNCHRONOUS getters for backward compatibility
const getDb = () => exports.firebaseManager.getDb();
exports.getDb = getDb;
const getFirebaseAuth = () => exports.firebaseManager.getAuthSync();
exports.getFirebaseAuth = getFirebaseAuth;
const getFirebaseStorage = () => exports.firebaseManager.getStorageSync();
exports.getFirebaseStorage = getFirebaseStorage;
const getFirebaseFunctions = () => exports.firebaseManager.getFunctionsSync();
exports.getFirebaseFunctions = getFirebaseFunctions;
const getFirebaseAnalytics = () => exports.firebaseManager.getAnalyticsSync();
exports.getFirebaseAnalytics = getFirebaseAnalytics;
const getGoogleProvider = () => exports.firebaseManager.getGoogleAuthProvider();
exports.getGoogleProvider = getGoogleProvider;
const isFirebaseInitialized = () => exports.firebaseManager.isReady();
exports.isFirebaseInitialized = isFirebaseInitialized;
// Export async versions for new code
const getFirestoreAsync = () => exports.firebaseManager.getFirestore();
exports.getFirestoreAsync = getFirestoreAsync;
const getAuthAsync = () => exports.firebaseManager.getAuth();
exports.getAuthAsync = getAuthAsync;
const getStorageAsync = () => exports.firebaseManager.getStorage();
exports.getStorageAsync = getStorageAsync;
const getFunctionsAsync = () => exports.firebaseManager.getFunctions();
exports.getFunctionsAsync = getFunctionsAsync;
const getAnalyticsAsync = () => exports.firebaseManager.getAnalytics();
exports.getAnalyticsAsync = getAnalyticsAsync;
const getAppAsync = () => exports.firebaseManager.getApp();
exports.getAppAsync = getAppAsync;
const getFirebaseApp = () => exports.firebaseManager.getApp(); // For backward compatibility
exports.getFirebaseApp = getFirebaseApp;
// Auto-initialize on import (safe, idempotent) - Skip in React Native AND Capacitor Native
// This allows index.tsx to explicitly coordinate initialization order
if (typeof navigator === 'undefined' || (navigator.product !== 'ReactNative' && !window.Capacitor)) {
    exports.firebaseManager.initialize().catch(error => {
        console.error('❌ FirebaseManager: Auto-initialization failed:', error);
    });
}
else {
    console.log('🚫 Skipping auto-init in native environment to allow coordinated boot');
}
exports.default = exports.firebaseManager;
